export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13881.542e58d3.jpg";